import React, { useState } from "react";
import styled from "styled-components";
import DataTable from "../components/DataTable";
import apiClient from "../utils/apiClient";
import Components from "../components";
import { Helmet } from "react-helmet-async";
import PageTitle from "../components/PageTitle";
import { Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const { Popup, InputBlock } = Components;

const Content = styled.div`
  width: auto;
  flex: 1;
  padding: 40px 32px;
  margin-inline-start: 30px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
`;

const HeadTabMenu = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

const PopupContent = styled.div`
  padding: 20px;
  text-align: center;

  & h3 {
    margin-bottom: 20px;
  }

  & > div {
    margin-bottom: 20px;
  }
`;

const S2SConformation = () => {
  const { t } = useTranslation();

  const [selectedDelegation, setSelectedDelegation] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [refreshTable, setRefreshTable] = useState(0);
  const [showClientsPopup, setShowClientsPopup] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);

  const handleApprove = async (delegationId) => {
    try {
      await apiClient.post("/s2s/sms/send", { delegation_id: delegationId });
      setSelectedDelegation(delegationId);
      setShowPopup(true);
    } catch (error) {
      console.error("Ошибка при отправке SMS-кода:", error);
    }
  };

  const handleConfirmSms = async () => {
    try {
      await apiClient.post("/s2s/sms/verify", {
        delegation_id: selectedDelegation,
        smsCode,
        action: "approve",
      });

      setShowPopup(false);
      setRefreshTable((prev) => prev + 1);
    } catch (error) {
      console.error("Ошибка при подтверждении SMS-кода:", error);
    }
  };

  const handleRefresh = () => {
    setRefreshTable((prev) => prev + 1);
  };

  const handleShowClients = (clientsFio) => {
    setSelectedClients(clientsFio);
    setShowClientsPopup(true);
  };

  return (
    <Content>
      <Helmet>
        <title>{t("s2sConfirmation.metaTitle")}</title>
        <meta
          name="description"
          content={t("s2sConfirmation.metaDescription")}
        />
      </Helmet>

      <PageTitle>{t("s2sConfirmation.title")}</PageTitle>

      <HeadTabMenu>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleRefresh}
          fullWidth
        >
          {t("s2sConfirmation.refresh")}
        </Button>
      </HeadTabMenu>

      <DataTable
        path="/s2s/pending"
        columns={[
          {
            field: "id",
            headerName: t("s2sConfirmation.columns.assignmentId"),
            flex: 1,
          },
          {
            field: "from_fio",
            headerName: t("s2sConfirmation.columns.from"),
            flex: 1,
          },
          {
            field: "to_fio",
            headerName: t("s2sConfirmation.columns.to"),
            flex: 1,
          },
          {
            field: "status",
            headerName: t("s2sConfirmation.columns.status"),
            flex: 1,
          },
          {
            field: "clients",
            headerName: t("s2sConfirmation.columns.clients"),
            flex: 1,
            renderCell: (params) => (
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => handleShowClients(params.row.clients_fio)}
              >
                {t("s2sConfirmation.view")}
              </Button>
            ),
          },
          {
            field: "actions",
            headerName: t("s2sConfirmation.columns.action"),
            flex: 1,
            renderCell: (params) => (
              <Button
                size="small"
                variant="contained"
                color="success"
                onClick={() => handleApprove(params.row.id)}
              >
                {t("s2sConfirmation.approve")}
              </Button>
            ),
          },
        ]}
        checkboxSelection={false}
        isShowSearch={false}
        refresh={refreshTable}
      />

      {showPopup && (
        <Popup
          show={showPopup}
          onClose={() => setShowPopup(false)}
          ContentComponent={() => (
            <PopupContent>
              <h3>{t("s2sConfirmation.smsConfirmTitle")}</h3>

              <InputBlock>
                <TextField
                  label={t("s2sConfirmation.smsCode")}
                  name="sms_code"
                  value={smsCode}
                  onChange={(e) => setSmsCode(e.target.value)}
                  required
                  fullWidth
                  size="small"
                />
              </InputBlock>

              <Button
                variant="contained"
                color="primary"
                onClick={handleConfirmSms}
              >
                {t("s2sConfirmation.confirm")}
              </Button>
            </PopupContent>
          )}
        />
      )}

      {showClientsPopup && (
        <Popup
          show={showClientsPopup}
          onClose={() => setShowClientsPopup(false)}
          ContentComponent={() => (
            <PopupContent>
              <h3>{t("s2sConfirmation.clientsListTitle")}</h3>

              {selectedClients && Array.isArray(selectedClients) ? (
                <ul>
                  {selectedClients.map((client, idx) => (
                    <li key={idx}>{client}</li>
                  ))}
                </ul>
              ) : (
                <div>{t("s2sConfirmation.noData")}</div>
              )}

              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setShowClientsPopup(false)}
              >
                {t("s2sConfirmation.close")}
              </Button>
            </PopupContent>
          )}
        />
      )}
    </Content>
  );
};

export default S2SConformation;
